import React, {ReactElement} from 'react';
import Modal from 'shared/components/modal';
import {useModal} from 'src/hooks/useModal';
import {VERIFY_PHONE_MODAL} from 'shared/actions/verify-mobile';

const MODAL_ID = 'ARE_YOU_SURE_MODAL';

export default function AreYouSureModal(): ReactElement {
  const modalSettings = useModal(MODAL_ID);
  const handleVerify = (): void => modalSettings.closeAndOpen(VERIFY_PHONE_MODAL);
  return (
    <Modal show={modalSettings.isOpen} onClose={modalSettings.close}>
      <Modal.TextHeader onClose={modalSettings.close}>Canceling Verification</Modal.TextHeader>
      <Modal.Body>
        <p>
          Are you sure you want to cancel? Your phone number will not be saved until you enter your
          verification code.
        </p>
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          text: 'Verify',
          onClick: handleVerify,
        }}
        secondaryButton={{
          text: 'Cancel',
          onClick: modalSettings.close,
          rightAligned: true,
        }}
      />
    </Modal>
  );
}
